export const CHECKOUT_URL =
  'https://mapas-visuales-de-enfermeria.impultienda.ar/checkout'

/* Todos los botones e imágenes llevan a la sección de compra */
export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/hzp18BSyRtZZWyc6f9jhgp/Pack_visual_de_enfermeria_profesional.png'

export const PRODUCT_NAME = 'MEGA PACK 250+ MAPAS VISUALES DE ENFERMERÍA'

export const PRICE = '$19.990'

export const BONUS_TOTAL = '$39.950'

/* 1. PROBLEMA */
export const problems = [
  {
    emoji: '📚',
    title: 'DEMASIADA INFORMACIÓN',
    desc: 'Tienes apuntes, libros y archivos PDF llenos de información, pero te cuesta resumir lo importante y recordar cada concepto cuando necesitas estudiarlo.',
  },
  {
    emoji: '🧠',
    title: 'ESTUDIAS, PERO TE OLVIDAS',
    desc: 'Lees una y otra vez anatomía, patologías, farmacología y procedimientos, pero después confundes términos, valores, síntomas y funciones.',
  },
  {
    emoji: '⏰',
    title: 'TE FALTA UN MÉTODO',
    desc: 'Quieres estudiar de manera más organizada, relacionar conceptos y prepararte para los exámenes, pero no sabes qué repasar primero ni cómo conectar los temas.',
  },
  {
    emoji: '😣',
    title: 'SIGUES POSTERGANDO',
    desc: 'Se acerca una evaluación y todavía tienes demasiados temas pendientes. Pasas horas organizando apuntes en lugar de aprovechar ese tiempo para aprender.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    emoji: '📘',
    title: 'FUNDAMENTOS DE ENFERMERÍA Y ANATOMÍA HUMANA',
    desc: '45 mapas visuales para comprender anatomía, sistemas del cuerpo humano, signos vitales, valoración del paciente, fundamentos de enfermería y conceptos esenciales.',
  },
  {
    emoji: '📗',
    title: 'PATOLOGÍAS Y FISIOPATOLOGÍA',
    desc: '45 mapas visuales para estudiar enfermedades frecuentes, causas, síntomas, alteraciones del organismo, factores de riesgo y cuidados generales de enfermería.',
  },
  {
    emoji: '📙',
    title: 'FARMACOLOGÍA Y ADMINISTRACIÓN DE MEDICAMENTOS',
    desc: '45 mapas visuales para comprender grupos farmacológicos, mecanismos de acción, vías de administración, efectos adversos y principios de seguridad medicamentosa.',
  },
  {
    emoji: '📕',
    title: 'PROCEDIMIENTOS Y CUIDADOS DE ENFERMERÍA',
    desc: '45 mapas visuales sobre valoración, bioseguridad, higiene, heridas, sondas, accesos venosos, cuidados hospitalarios y procedimientos fundamentales.',
  },
  {
    emoji: '📒',
    title: 'ECG, LABORATORIO Y URGENCIAS DE ENFERMERÍA',
    desc: '45 mapas visuales para estudiar electrocardiogramas, valores de laboratorio, alteraciones clínicas, reconocimiento de urgencias y prioridades de valoración.',
  },
  {
    emoji: '📓',
    title: 'ENFERMERÍA ESPECIALIZADA Y REPASO INTEGRAL',
    desc: '45 mapas visuales sobre enfermería pediátrica, geriátrica, cuidados especializados, situaciones clínicas y repaso de conocimientos esenciales.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    title: 'GUÍA VISUAL DE VALORES DE LABORATORIO',
    desc: '36 fichas visuales para estudiar análisis clínicos, valores de referencia, alteraciones frecuentes e interpretación básica, con ejercicios de práctica.',
    value: '$7.990',
  },
  {
    title: '100 FICHAS VISUALES DE MEDICAMENTOS',
    desc: '100 fichas para repasar medicamentos, grupos farmacológicos, indicaciones generales, mecanismos de acción, efectos adversos y precauciones de enfermería.',
    value: '$5.990',
  },
  {
    title: 'CÁLCULO DE DOSIS, DILUCIONES Y GOTEO',
    desc: '36 fichas visuales y 50 ejercicios simulados para practicar conversiones, concentraciones, cálculos de dosis, diluciones y velocidades de infusión.',
    value: '$6.990',
  },
  {
    title: '50 CASOS CLÍNICOS DE ENFERMERÍA',
    desc: '50 situaciones clínicas simuladas con valoración, signos vitales, problemas prioritarios, preguntas y respuestas explicadas para desarrollar razonamiento clínico.',
    value: '$8.990',
  },
  {
    title: '100 PREGUNTAS DE EXAMEN CON RESPUESTAS EXPLICADAS',
    desc: '100 preguntas de opción múltiple organizadas en 5 simulacros para evaluar conocimientos, identificar errores y reforzar los temas importantes.',
    value: '$9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    emoji: '🧠',
    title: 'MENOS CONFUSIÓN',
    desc: 'Deja de estudiar con apuntes desordenados y comienza a relacionar conceptos mediante mapas visuales, cuadros, esquemas y explicaciones organizadas.',
  },
  {
    emoji: '📚',
    title: 'MÁS CONOCIMIENTO PRÁCTICO',
    desc: 'Repasa anatomía, patologías, medicamentos, procedimientos, laboratorio y urgencias con recursos que combinan teoría, ejemplos y actividades.',
  },
  {
    emoji: '🔬',
    title: 'COMPRENDE LO QUE ESTUDIAS',
    desc: 'Empieza a relacionar síntomas, funciones del organismo, resultados de laboratorio y cuidados de enfermería en lugar de memorizar conceptos aislados.',
  },
  {
    emoji: '🎓',
    title: 'MÁS PREPARACIÓN PARA TUS EXÁMENES',
    desc: 'Construye una base de conocimientos, practica con casos clínicos y evalúa lo aprendido con preguntas y respuestas explicadas.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Estoy en segundo año y sentía que tenía mil apuntes y ninguno servía. Con los mapas del tomo 1 por fin entendí cómo se conectan los sistemas del cuerpo con la valoración del paciente. Ahora antes de cada clase repaso el mapa del tema y llego sabiendo de qué se va a hablar. Dejé de pasar las noches pasando resúmenes en limpio.',
    author: 'Camila Herrera',
    role: 'Estudiante de 2.º año de Enfermería, 22 años',
    location: 'Córdoba, Argentina',
  },
  {
    quote:
      'Me cambié de carrera a los 27 y anatomía me tenía frustrado. Leía el libro tres veces y al otro día no recordaba nada. Los mapas visuales de anatomía y fisiopatología me ayudaron a ver causa, síntoma y cuidado en una sola hoja. Aprobé el parcial de patologías con 8 y es la primera vez que siento que entiendo lo que estudio.',
    author: 'Lucas Benítez',
    role: 'Estudiante de 1.er año de Enfermería, 27 años',
    location: 'Rosario, Argentina',
  },
  {
    quote:
      'Soy mamá de dos y estudio de noche, así que mi tiempo es oro. Farmacología era mi pesadilla: confundía grupos, efectos adversos y precauciones. Con las 100 fichas de medicamentos repaso 15 minutos en el colectivo y en la sala de espera del pediatra. En el último examen reconocí cada grupo farmacológico sin dudar.',
    author: 'Agustina Ríos',
    role: 'Estudiante de Enfermería y mamá, 31 años',
    location: 'Mendoza, Argentina',
  },
  {
    quote:
      'Lo que más uso son los casos clínicos y los ejercicios de cálculo de dosis. En las prácticas me ponía muy nerviosa con los goteos y las diluciones. Hice los 50 ejercicios simulados dos veces y ahora razono el cálculo paso a paso en vez de memorizar fórmulas. Mi instructora notó la diferencia en la segunda rotación.',
    author: 'Rocío Fernández',
    role: 'Estudiante de 3.er año de Enfermería, 24 años',
    location: 'La Plata, Argentina',
  },
  {
    quote:
      'Trabajé años como auxiliar y volví a estudiar para la licenciatura. Hacía mucho que no rendía un examen y tenía miedo. Armé mi plan con los mapas de ECG, laboratorio y urgencias y cerré cada semana con un simulacro de las 100 preguntas. Las respuestas explicadas me mostraron exactamente dónde fallaba. Rendí el final tranquila y aprobé.',
    author: 'Daniela Morales',
    role: 'Auxiliar de enfermería y estudiante de Licenciatura, 38 años',
    location: 'San Miguel de Tucumán, Argentina',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El contenido comienza con fundamentos y avanza hacia temas de mayor complejidad.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Anatomía, patologías, farmacología, procedimientos, ECG, laboratorio, urgencias y cuidados especializados de enfermería.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Incluye ejercicios de cálculo, casos clínicos y preguntas de examen con respuestas explicadas.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos con tu compra.',
  },
  { q: '¿Es un pago único?', a: 'Sí. Realizas un solo pago, sin mensualidades.' },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. El producto se entrega en formato digital después de confirmarse el pago.',
  },
  {
    q: '¿Esto me habilita profesionalmente?',
    a: 'No. Es material educativo complementario y no reemplaza estudios oficiales, prácticas supervisadas ni certificaciones.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. Puedes organizar tus sesiones de estudio y repasar los materiales cuando lo necesites.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Puedes escribir a soportescmdigital@gmail.com.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Micaela Fernández', city: 'Córdoba', minutes: 2 },
  { name: 'Sofía Romero', city: 'Rosario', minutes: 4 },
  { name: 'Brenda Gómez', city: 'Buenos Aires', minutes: 7 },
  { name: 'Julián Díaz', city: 'Mendoza', minutes: 11 },
  { name: 'Paula Medina', city: 'La Plata', minutes: 15 },
  { name: 'Milagros Torres', city: 'Mar del Plata', minutes: 19 },
  { name: 'Lucía Acosta', city: 'Salta', minutes: 24 },
  { name: 'Ayelén Molina', city: 'San Miguel de Tucumán', minutes: 29 },
  { name: 'Nahuel Ríos', city: 'Neuquén', minutes: 33 },
  { name: 'Julieta Herrera', city: 'Santa Fe', minutes: 40 },
]
